// SocietyRegistration.jsx
import React from "react";

export default function SocietyRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Society Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Society Registration Support in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides assistance for Society Registration
            under applicable laws, helping groups with charitable, educational,
            cultural, or social objectives to obtain formal legal status.
          </p>
          <p className="text-gray-700">
            From preparing the Memorandum of Association and rules to organizing
            member details and address proofs, the registration process is
            handled in a structured manner so that your society can start
            operating with clarity and compliance.
          </p>
        </div>

        {/* Right: Image (square) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/1181395/pexels-photo-1181395.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Group planning society registration and documentation"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Society Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps the founding members collate and
              prepare the core documentation required for registering a society
              with the relevant authority.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Memorandum of Association (MOA) setting out the name, objects,
                  registered office, and details of the governing body and
                  founding members.
                </li>
                <li>
                  Rules and regulations / by‑laws of the society describing
                  membership, governance, meetings, and administration.
                </li>
                <li>
                  Identity proof of members and office bearers (Aadhaar,
                  passport, voter ID, or driving licence).
                </li>
                <li>
                  Residential address proof of key members and office bearers
                  (utility bill, bank statement, or similar).
                </li>
                <li>
                  Registered office address proof of the society (rent / lease
                  agreement or ownership proof, recent utility bill, and NOC
                  from owner where applicable).
                </li>
                <li>
                  Passport-size photographs and contact details of members of
                  the governing body.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm offers focused support for societies, combining knowledge
              of society law with practical documentation and process handling
              for smooth registration.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Society Law Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on eligibility, object clauses, governing body
                  structure, and core compliance expectations under applicable
                  societies legislation.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance in drafting and reviewing the Memorandum of
                  Association, rules, and supporting documents to keep records
                  consistent and registration‑ready.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Service Delivery
                </h3>
                <p className="text-gray-700 text-sm">
                  Professional, process‑driven support from the initial planning
                  stage through filing and follow‑up, offering dependable help
                  to set up your society.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
